import getEndPoint from './getEndpoint';
import actions from '../actions';
import store from '../store';

export async function securityQuestions(data, { env, jwtToken, accessToken }) {
    const endPoint = getEndPoint(env, 'apigeeOAuth');
    try {
        const response = await fetch(
            `${endPoint}v1/btcustomerportalservice/customerSecurityQuestions`,
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    Authorization: 'Bearer ' + accessToken
                }
            }
        );

        if (response.status === 200) {
            const res = await response.json();
            store.dispatch(actions.customer.receiveSecurityQuestions(res));
        } else {
            store.dispatch(actions.customer.error(response));
        }
    } catch (err) {
        store.dispatch(actions.customer.error(err));
    }
}

export async function validateSecurityQuestionAnswer(data, { env, jwtToken, accessToken }) {
    const endPoint = getEndPoint(env, 'apigeeOAuth');

    try {
        const response = await fetch(
            `${endPoint}v1/btcustomerportalservice/validateSecurityCustomerAnswers`,
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    Authorization: 'Bearer ' + accessToken
                }
            }
        );

        if (response.status === 200) {
            const res = await response.json();

            store.dispatch(actions.customer.receiveSecurityQuestionsValidation(res));
        } else {
            store.dispatch(actions.customer.error(response));
        }
    } catch (err) {
        store.dispatch(actions.customer.error(err));
    }
}



// WEBPACK FOOTER //
// ./src/modules/customer.js